import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { Firestore, getFirestore } from 'firebase/firestore';

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object

let appSingleton: FirebaseApp | undefined;
let firestoreSingleton: Firestore | undefined;
let authSingleton: Auth | undefined;
// Initialize Firebase

const initializeFirebase = () => {
  if (!getApps().length || !appSingleton) {
    appSingleton = initializeApp({
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APPID,
      databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
    });
  }
  firestoreSingleton = getFirestore(appSingleton!);
  authSingleton = getAuth(appSingleton!);
  return appSingleton;
};

initializeFirebase();

// Initialize Firebase Authentication and get a reference to the service
export const auth = authSingleton;
export const firestore = firestoreSingleton;
